import {Component, HostBinding, HostListener, Inject, OnDestroy} from '@angular/core';
import {Router} from '@angular/router';
import {TranslateService} from '@ngx-translate/core';
import {setLang, theme} from './common/const';
import {Subscription} from 'rxjs/Subscription';
import {Title} from '@angular/platform-browser';
import {environment} from '../environments/environment';
import {DOCUMENT} from '@angular/common';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnDestroy {

    subscription: Subscription;
    translateReady = false;
    showWarningMessage = false;
    @HostBinding('style.height') height = '';

    @HostListener('window:resize', ['$event'])
    onResize() {
        this.height = window.innerHeight + 'px';
    }

    constructor(
        private router: Router,
        private translate: TranslateService,
        private title: Title,
        @Inject(DOCUMENT) __doc
    ) {
        let lang = this.translate.getBrowserLang();
        if (lang !== 'es') {
            lang = 'es';
        }
        translate.setDefaultLang(lang);
        translate.use(lang);
        setLang(lang);

        __doc.querySelector('body').setAttribute('data-theme', theme);
        this.subscription = this.translate.onLangChange.subscribe((event) => {
            this.translateReady = true;
        });

        this.title.setTitle(`${environment.title}`);

        if (window.innerWidth <= 600) {
            this.height = window.innerHeight + 'px';
        }

        this.checkBrowserCompatibility();
    }

    checkBrowserCompatibility() {
        const ua = navigator.userAgent;
        const isWebGL2Supported = () => {
          return !!document.createElement('canvas').getContext('webgl')
        };
        const M = ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];
        if (/trident|msie/i.test(M[1]) || !isWebGL2Supported()) {
            this.showWarningMessage = true;
        }
    }

    ngOnDestroy() {
        if (this.subscription) {
            this.subscription.unsubscribe();
        }
    }

}



// WEBPACK FOOTER //
// ./src/app/app.component.ts